export const SCATTER_SHAPE_TRANSITION = 'fill-opacity 400ms ease, stroke-opacity 400ms ease';
